import React, { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet'
import { cn } from '@bem-react/classname'

import { Memo } from '@/hoc/Memo'
import { loadingSelector } from '@/core/services/Loading/store/loading.selector'
import { useAppDispatch, useAppSelector } from '@/core/store/hooks'
import { changeLoading } from '@/core/services/Loading/store/loading.slice'

import { Back } from '@/components/Back'
import { Title } from '@/components/Title'

import './ErrorPage.scss'

const cnError = cn('Error')

export const ErrorPage: FC = Memo(() => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const isLoading = useAppSelector(loadingSelector)

  useEffect(() => {
    if (isLoading) {
      dispatch(changeLoading(false))
    }
  }, [isLoading])

  return (
    <>
      <Helmet>
        <title>{t('Page not found')} | DTM</title>
      </Helmet>
      <div className={cnError()}>
        <Back />

        <div className={cnError('text')}>
          <Title className={cnError('title')}>{t('404')}</Title>
          <div className={cnError('subheader')}>
            {t('Sorry, page not found')}
          </div>
        </div>
      </div>
    </>
  )
})
